// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App'
import router from './router'
import axios from 'axios'
// import vueg from 'vueg'
import store from '@/store/'
import throttle from 'lodash/throttle'
import debounce from 'lodash/debounce'
import {VTooltip} from 'v-tooltip'

import 'vueg/css/transition-min.css'

VTooltip.options.defaultTrigger = 'click hover'
VTooltip.options.disposeTimeout = 5000

Vue.use(Vuetify)
Vue.directive('tud-tooltip', VTooltip)

// Vue.directive('tabs-loaded', {
//   componentUpdated (el, binding, vnode) {
//     setTimeout(() => {
//       vnode.componentInstance.onResize()
//     }, 1000)
//   }
// })

// Vue.use(vueg, router, {shadow: false, forwardAnim: 'fadeInRightBig', backAnim: 'fadeInLeftBig', duration: '0.5'})
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$throttle = throttle
Vue.prototype.$debounce = debounce

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js